import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-5" }
const _hoisted_2 = { class: "flex gap-x-2" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-base leading-6 font-semibold text-gray-700" }, "Communications", -1)
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col pt-3"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-base leading-6 font-semibold text-gray-700" }, "CRM", -1)
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col pt-3"
}

import { Component, computed, ref } from "vue"
import { ArrowCircleRightIcon, ClockIcon, SearchIcon } from "@heroicons/vue/outline"
import ArrowDown from "@/components/icons/ArrowDown.vue"
import ActionCard from "@/components/workflows/sidebar/action/ActionCard.vue"
import ActionItem from "@/components/workflows/sidebar/action/ActionItem.vue"
import MergeIcon from "@/components/icons/MergeIcon.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GreenMailIcon from "@/components/workflows/icons/GreenMailIcon.vue"
import BlueUsersIcon from "@/components/workflows/icons/BlueUsersIcon.vue"
import NoteComponent from "@/components/workflows/sidebar/action/crm/NoteComponent.vue"
import PropertyValueComponent from "@/components/workflows/sidebar/action/crm/PropertyValueComponent.vue"
import LeadDistributionComponent from "@/components/workflows/sidebar/action/crm/LeadDistributionComponent.vue"
import SendEmailComponent from "@/components/workflows/sidebar/action/communications/SendEmailComponent.vue"
import BranchSidebarComponent from "@/components/workflows/sidebar/BranchSidebarComponent.vue"
import DelaySidebarComponent from "@/components/workflows/sidebar/DelaySidebarComponent.vue"
import SendTextMessageComponent from "@/components/workflows/sidebar/action/communications/SendTextMessageComponent.vue"
import ApplyTagsComponent from "@/components/workflows/sidebar/action/crm/ApplyTagsComponent.vue"
import { useWorkflowStore } from "@/stores/workflow"
import { ActionNodeType } from "@/shared/models/workflow"
import EnrollOrUnenrollWorkflowComponent from "@/components/workflows/sidebar/action/crm/EnrollOrUnenrollWorkflowComponent.vue"
import DeleteContactsComponent from "./action/crm/DeleteContactsComponent.vue"
import CreateTaskSidebarComponent from "@/components/workflows/sidebar/action/crm/CreateTaskSidebarComponent.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'StartSidebarComponent',
  emits: ["changeAction"],
  setup(__props, { emit: __emit }) {

const workflowStore = useWorkflowStore()

const emit = __emit

const isOpenCommunication = ref(true)
const isOpenCrm = ref(true)

const communicationItems = [
    {
        title: "Send email",
        description: "Send an email to contacts",
        sidebarComponent: SendEmailComponent,
    },
    {
        title: "Send text message",
        description: "Send a text message to contacts",
        sidebarComponent: SendTextMessageComponent,
    },
    {
        title: "Send in-app notification (Internal)",
        description: "Send a notification to any of your team members",
        sidebarComponent: BranchSidebarComponent,
    },
    {
        title: "Communication Delay",
        description: "Send an email to any of your team members",
        sidebarComponent: BranchSidebarComponent,
    },
]

const crmItems = [
    {
        title: "Property value",
        description: "Set, clear, copy, increase or decrease",
        sidebarComponent: PropertyValueComponent,
    },
    {
        title: "Lead Distribution",
        description: "Assigning, Availability",
        sidebarComponent: LeadDistributionComponent,
    },
    {
        title: "Note",
        description: "Description of item",
        sidebarComponent: NoteComponent,
    },
    {
        title: "Create task",
        description: "Create a task for an agent",
        sidebarComponent: CreateTaskSidebarComponent,
    },
    {
        title: "Enroll or Unenroll from workflows",
        description: "Configure action...",
        sidebarComponent: EnrollOrUnenrollWorkflowComponent,
    },
    {
        title: "Create record",
        description: "Description of item",
        sidebarComponent: DelaySidebarComponent,
    },
    {
        title: "Delete contact",
        description: "Description of item",
        sidebarComponent: DeleteContactsComponent,
    },
    {
        title: "Manage communication subscriptions",
        description: "Description of item",
        sidebarComponent: BranchSidebarComponent,
    },
    {
        title: "Contact owner",
        description: "Description of item",
        sidebarComponent: BranchSidebarComponent,
    },
    {
        title: "Add or remove tags",
        description: "Add, remove, edit",
        sidebarComponent: ApplyTagsComponent,
    },
    {
        title: "Property Alert(s)",
        description: "Description of item",
        sidebarComponent: BranchSidebarComponent,
    },
    {
        title: "Suggest Property",
        description: "Description of item",
        sidebarComponent: BranchSidebarComponent,
    },
]

const searchTerm = ref("")

const filteredCommunicationItems = computed(() =>
    communicationItems.filter((item) => item.title.toLowerCase().includes(searchTerm.value.toLowerCase()))
)

const filteredCrmItems = computed(() =>
    crmItems.filter((item) => item.title.toLowerCase().includes(searchTerm.value.toLowerCase()))
)

const iconStyle = computed(() => [workflowStore.disabledBranches ? "fill-gray-400" : "", "h-5 w-5 "])

function enterBranches() {
    if (workflowStore.disabledBranches) {
        return
    }
    changeAction({
        title: "Configure branch...",
        sidebarComponent: BranchSidebarComponent,
        type: ActionNodeType.branch,
    })
}
function changeAction(event: { title: string; sidebarComponent?: Component; description?: string; type: string }) {
    emit("changeAction", event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ActionCard, {
        title: "Delay",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
                    changeAction({
                        title: 'Configure delay...',
                        sidebarComponent: DelaySidebarComponent,
                        type: _unref(ActionNodeType).delay,
                    })
                ))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ClockIcon), { class: "h-5 w-5 text-gray-900" })
        ]),
        _: 1
      }),
      _createVNode(ActionCard, {
        title: "Branch",
        disabled: _unref(workflowStore).disabledBranches,
        onClick: enterBranches
      }, {
        default: _withCtx(() => [
          _createVNode(MergeIcon, {
            class: _normalizeClass(iconStyle.value)
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(ActionCard, {
        title: "Go to workflow",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeAction({ title: 'Go to workflow...' })))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowCircleRightIcon), { class: "h-5 w-5 text-gray-900" })
        ]),
        _: 1
      }),
      _createVNode(ActionCard, {
        title: "Go to action",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (changeAction({ title: 'Go to action...' })))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowCircleRightIcon), { class: "h-5 w-5 text-gray-900" })
        ]),
        _: 1
      })
    ]),
    _createVNode(GgmsInput, {
      "input-class": "bg-gray-100 border-0",
      modelValue: searchTerm.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchTerm).value = $event)),
      small: true,
      iconEnd: _unref(SearchIcon),
      placeholder: "Search"
    }, null, 8, ["modelValue", "iconEnd"]),
    _createElementVNode("div", _hoisted_3, [
      (filteredCommunicationItems.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "flex gap-x-2 cursor-pointer",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (isOpenCommunication.value = !isOpenCommunication.value))
            }, [
              _createVNode(GreenMailIcon),
              _hoisted_5,
              (isOpenCommunication.value)
                ? (_openBlock(), _createBlock(ArrowDown, {
                    key: 0,
                    class: "fill-gray-700"
                  }))
                : (_openBlock(), _createBlock(ArrowDown, {
                    key: 1,
                    class: "rotate-180 fill-gray-700"
                  }))
            ]),
            _createVNode(_Transition, null, {
              default: _withCtx(() => [
                (isOpenCommunication.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCommunicationItems.value, (item) => {
                        return (_openBlock(), _createBlock(ActionItem, {
                          key: item.title,
                          title: item.title,
                          color: "teal-600",
                          description: item.description,
                          onClick: ($event: any) => (changeAction(item))
                        }, null, 8, ["title", "description", "onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (filteredCrmItems.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "flex gap-x-2 mt-6 cursor-pointer",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (isOpenCrm.value = !isOpenCrm.value))
            }, [
              _createVNode(BlueUsersIcon),
              _hoisted_8,
              (isOpenCrm.value)
                ? (_openBlock(), _createBlock(ArrowDown, {
                    key: 0,
                    class: "fill-gray-700"
                  }))
                : (_openBlock(), _createBlock(ArrowDown, {
                    key: 1,
                    class: "rotate-180 fill-gray-700"
                  }))
            ]),
            _createVNode(_Transition, null, {
              default: _withCtx(() => [
                (isOpenCrm.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCrmItems.value, (item) => {
                        return (_openBlock(), _createBlock(ActionItem, {
                          key: item.title,
                          title: item.title,
                          color: "blue-600",
                          description: item.description,
                          onClick: ($event: any) => (changeAction(item))
                        }, null, 8, ["title", "description", "onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})